import React from 'react';
import { Component } from 'react';
import './LogInScreen.scss';
import apiRoutingService from '../../../services/apiRoutingService';
import { SimpleButton } from '../../buttons/simple/SimpleButton';
import { IconButton, InputAdornment, TextField } from "@mui/material";
import routingService from '../../../services/routingService';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

interface LogInScreenProps {
}

interface LogInScreenState {
    email: string;
    password: string;
    message: string;
    isSuccess: boolean;
    isLoading: boolean;
    emailError: boolean;
    emailMessage: string;
    showPassword: boolean;
}

export default class LogInScreen extends Component<LogInScreenProps, LogInScreenState> {
    constructor(props: LogInScreenProps) {
        super(props);

        this.state = {
            email: "",
            password: "",
            message: "",
            isSuccess: true,
            isLoading: false,
            emailError: false,
            emailMessage: "",
            showPassword: false
        }
        this.login = this.login.bind(this);
    }

    readonly errorFromServer = "Niepoprawny email i/lub hasło";
    readonly buttonText = "Zaloguj się";
    readonly buttonLoadingText = "Loguję...";
    readonly registerButtonText = "Nie masz konta? Dołącz do nas!";
    readonly dontRememberPass = "Nie pamiętam hasła";
    readonly wrongEmail = "Błędny adres email";



    private async login(e: any) {
        e.preventDefault();
        let { email, password } = this.state;
        let isOk = await this.sendRequest(email, password);

        if (!isOk) {
            this.setState({ isSuccess: false, message: this.errorFromServer });
            return;
        }

        this.setState({ email: "", password: "", isSuccess: true, message: "" });

        window.location.replace(routingService.getUserAccountStatusPageRoute())
    }

    private async sendRequest(email: string, password: string): Promise<boolean> {
        let result = false;

        this.setState({ isLoading: true });
        try {
            result = await apiRoutingService.logIn(email, password);
        }
        catch { }
        this.setState({ isLoading: false });
        return result;
    }

    private passwordInputChange(value: string) {
        this.setState({
            password: value
        });
    }

    private emailInputChange(value: string) {
        this.setState({
            email: value
        });
    }

    private validateEmail() {
        let { email } = this.state;
        let error = false;
        let message = "";

        if (!this.isEmailValid(email)) {
            error = true;
            message = this.wrongEmail;
        }

        this.setState({
            emailError: error,
            emailMessage: message
        });
    }

    private isEmailValid(value: unknown): boolean {
        if (value === null || value === undefined) {
            return true;
        }

        if (typeof value !== "string") {
            return false;
        }

        let email = value as string;

        if (email.includes("\r") || email.includes("\n")) {
            return false;
        }

        const index = email.indexOf("@");

        return (
            index > 0 &&
            index !== email.length - 1 &&
            index === email.lastIndexOf("@")
        );
    }

    public render() {
        let { isSuccess, message, email, password, isLoading, showPassword } = this.state;
        let messageCss = isSuccess ? "message message-success" : "message message-error";

        let inputStyles = {
            input: { color: "white" },
            label: { color: "white" },
            "& .MuiInput-underline:before": {
                borderBottomColor: "white",
            },
            "& .MuiInput-underline:hover:before": {
                borderBottomColor: "white !important",
            },
            "& .MuiInput-underline:after": {
                borderBottomColor: "white",
            },
            "& .Mui-error:before, & .Mui-error:after": {
                borderBottomColor: "red !important",
            },
        };

        return (
            <div className="log-in-container">
                <div className="row">
                    <div className="col">
                        <form id="log-in-form">

                            <h1>Zaloguj się</h1>

                            <div className="form-textfields">
                                <TextField
                                    id="login-email"
                                    label="Adres email"
                                    required
                                    variant="standard"
                                    type="email"
                                    value={email}
                                    onChange={(e) => this.emailInputChange(e.target.value)}
                                    onBlur={(e) => this.validateEmail()}
                                    error={this.state.emailError}
                                    helperText={this.state.emailMessage}
                                    sx={inputStyles}
                                />
                                <br />

                                <TextField
                                    id="login-password"
                                    label="Hasło"
                                    required
                                    variant="standard"
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => this.passwordInputChange(e.target.value)}
                                    sx={inputStyles}
                                    slotProps={{
                                        input: {
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    className="show-password-icon"
                                                >
                                                    <IconButton
                                                        onClick={() => this.setState({ showPassword: !showPassword })}
                                                        onMouseDown={(e) => e.preventDefault()}
                                                        edge="end"
                                                        sx={{ color: "white" }}
                                                    >
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                />
                                <br />
                            </div>
                            {/* <a href={routingService.getMainPageRoute()} className="forgot-password gray-link">
                                Nie pamiętam hasła
                            </a> */}

                            <div className="log-in-button">
                                <SimpleButton
                                    text={isLoading ? this.buttonLoadingText : this.buttonText}
                                    onClick={(e) => this.login(e)}
                                />
                            </div>

                            <div className="form-group">
                                <p className={messageCss}>{message}</p>
                            </div>

                            <a href={routingService.getSignUpPageRoute()} className="go-to-register gray-link">
                                Nie masz konta? Dołącz do nas!
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}